const mediaItems = [
  {
    id: 1,
    title: '夏日烟火',
    tag: '日剧 · 更新至第8集',
    desc: '一部关于青春与梦想的夏日物语，在烟花绽放的瞬间，所有的秘密都将浮出水面。',
    img: 'https://readdy.ai/api/search-image?query=A%20Japanese%20drama%20scene%20with%20warm%20summer%20evening%20atmosphere%2C%20two%20young%20people%20standing%20by%20a%20river%20under%20fireworks%2C%20cinematic%20lighting%20with%20soft%20golden%20tones%2C%20emotional%20and%20nostalgic%20mood%2C%20film%20grain%20texture%2C%20Japanese%20drama%20aesthetic&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '暗夜追踪',
    tag: '美剧 · 第二季热播中',
    desc: 'FBI探员深入连环案件，每一集都是一场高智商的猫鼠游戏，悬疑感拉满。',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20crime%20thriller%20American%20TV%20series%20scene%2C%20a%20detective%20in%20a%20dimly%20lit%20alley%20at%20night%20with%20neon%20reflections%2C%20rain-slicked%20streets%2C%20intense%20atmosphere%2C%20cinematic%20noir%20style%20with%20deep%20shadows%20and%20cool%20blue%20accents&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '长安十二时辰',
    tag: '国产剧 · 全集已完结',
    desc: '盛唐长安，一场惊天阴谋正在酝酿，十二时辰内拯救一座城的命运。',
    img: 'https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20drama%20scene%20set%20in%20ancient%20Tang%20Dynasty%20Changan%2C%20traditional%20architecture%20with%20lanterns%20and%20flowing%20silk%20robes%2C%20warm%20candlelit%20atmosphere%2C%20epic%20cinematic%20composition%2C%20rich%20red%20and%20gold%20color%20palette&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '星际迷航：新纪元',
    tag: '欧美大片 · 4K超清',
    desc: '人类文明的最后希望寄托在一艘星际飞船上，浩瀚宇宙中的生存之战。',
    img: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20movie%20scene%20with%20a%20massive%20spaceship%20floating%20near%20a%20colorful%20nebula%2C%20stars%20and%20galaxies%20in%20the%20background%2C%20cinematic%20space%20opera%20style%2C%20deep%20space%20atmosphere%20with%20purple%20and%20teal%20cosmic%20colors&width=640&height=360&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              每日精选热播影视，好剧不停歇
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaItems.map((item) => (
              <a
                key={item.id}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-2 left-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded whitespace-nowrap">
                    {item.tag}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 text-2xl">
                      <i className="ri-play-fill" />
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-600 line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}